class Storage {
    constructor(storage) {
        this.storage = storage;
    }

    get(key, defaultValue = null) {
        let value = this.storage.getItem(key) || defaultValue;

        if (value) {
            try {
                value = JSON.parse(value);
            } catch (error) {
                value = defaultValue;
            }
        }

        return value;
    }

    has(key) {
        return this.get(key) !== null;
    }

    set(key, value) {
        const newValue = JSON.stringify(value);

        this.storage.setItem(key, newValue);
    }

    remove(key) {
        this.storage.removeItem(key);
    }

    clear() {
        this.storage.clear();
    }

    pull(key, defaultValue) {
        const value = this.get(key, defaultValue);

        this.remove(key);

        return value;
    }
}

const LocalStorage = new Storage(window.localStorage);
const SessionStorage = new Storage(window.sessionStorage);

export default LocalStorage;

export { SessionStorage };
